import { getRecordValue } from '../utils/record';

type Height = keyof typeof heights;

export const heights = {
  s: 32,
  m: 48,
  l: 88,
  xl: 136,
  listItem: 67,
  navHeightDesktop: 88,
  modalContentMinHeight: 200,
  statusContentMinHeight: 240,
  duplicateButtonSize: 40,
  /** Recommended (not just AA-minimum) touch target for icon-only or compact interactive controls. */
  touch: 44,
} as const;

export const getHeight = (height: Height = 'm') => {
  return `${getRecordValue(heights, height)}px`;
};

type BorderRadius = keyof typeof borderRadius;

export const borderRadius = {
  xxs: 1,
  xs: 2,
  s: 4,
  m: 8,
  l: 12,
  xl: 16,
  xxl: 24,
} as const;

export const getBorderRadius = (size: BorderRadius = 'm') => {
  return `${getRecordValue(borderRadius, size)}px`;
};

type Width = keyof typeof widths;

export const widths = {
  minWidth: 48,
  form: 387,
  modal: 670,
  wideModal: 800,
  listContainer: 1280,
} as const;

export const getWidth = (width: Width) => {
  return `${getRecordValue(widths, width)}px`;
};
